/**
 * 화면 설정값(총괄 DEV-I-002 항목 5: 시간 값은 설정값으로 관리).
 * 서버가 index.html의 <meta name="growing-config">에 JSON으로 넣는다(인라인 스크립트 없이). 없거나 잘못되면 초기값.
 * 초기값: 화면 대기 4초, 재전송 1.5/3/6/8초, 조회 2초, 확인 30초(총괄 채택).
 */
import { DEFAULT_TIMING, type SubmitTiming } from '../core/submit-controller.js';
import { RESULT_CHECK_MS } from '../core/result-batch.js';
import { WORDS_CHECK_MS } from '../core/words-model.js';
import { QUIZ_CHECK_MS } from '../core/quiz-model.js';

const pos = (v: unknown): v is number => typeof v === 'number' && Number.isFinite(v) && v > 0 && v <= 600_000;

export function parseTiming(raw: unknown): SubmitTiming {
  const t = (raw !== null && typeof raw === 'object' ? (raw as Record<string, unknown>)['submit'] : null) as Record<string, unknown> | null;
  if (t === null || typeof t !== 'object') return DEFAULT_TIMING;
  const resend = Array.isArray(t['resendDelaysMs']) && t['resendDelaysMs'].length > 0 && t['resendDelaysMs'].every(pos) ? (t['resendDelaysMs'] as number[]) : DEFAULT_TIMING.resendDelaysMs;
  return {
    displayWaitMs: pos(t['displayWaitMs']) ? t['displayWaitMs'] : DEFAULT_TIMING.displayWaitMs,
    resendDelaysMs: resend,
    pollMs: pos(t['pollMs']) ? t['pollMs'] : DEFAULT_TIMING.pollMs,
    windowMs: pos(t['windowMs']) ? t['windowMs'] : DEFAULT_TIMING.windowMs,
  };
}

/** 결과 화면 조회 묶음 확인 제한(DEV-I-008, 초기값 30초). growing-config의 result.checkMs */
export function parseResultCheckMs(raw: unknown): number {
  const r = (raw !== null && typeof raw === 'object' ? (raw as Record<string, unknown>)['result'] : null) as Record<string, unknown> | null;
  return r !== null && typeof r === 'object' && pos(r['checkMs']) ? r['checkMs'] : RESULT_CHECK_MS;
}
export function readResultCheckMs(): number {
  try {
    const m = document.querySelector('meta[name="growing-config"]');
    return parseResultCheckMs(JSON.parse(m?.getAttribute('content') ?? '{}'));
  } catch {
    return RESULT_CHECK_MS;
  }
}

/** 내 단어장 조회 확인 제한(DEV-I-013, 초기값 30초, 목록·상세 각각). growing-config의 words.checkMs */
export function parseWordsCheckMs(raw: unknown): number {
  const r = (raw !== null && typeof raw === 'object' ? (raw as Record<string, unknown>)['words'] : null) as Record<string, unknown> | null;
  return r !== null && typeof r === 'object' && pos(r['checkMs']) ? r['checkMs'] : WORDS_CHECK_MS;
}
export function readWordsCheckMs(): number {
  try {
    const m = document.querySelector('meta[name="growing-config"]');
    return parseWordsCheckMs(JSON.parse(m?.getAttribute('content') ?? '{}'));
  } catch {
    return WORDS_CHECK_MS;
  }
}

/** 단어 시험 조회 확인 제한(DEV-I-020, 초기값 30초, 목록·시험·결과 각각). growing-config의 quiz.checkMs */
export function parseQuizCheckMs(raw: unknown): number {
  const r = (raw !== null && typeof raw === 'object' ? (raw as Record<string, unknown>)['quiz'] : null) as Record<string, unknown> | null;
  return r !== null && typeof r === 'object' && pos(r['checkMs']) ? r['checkMs'] : QUIZ_CHECK_MS;
}
export function readQuizCheckMs(): number {
  try {
    const m = document.querySelector('meta[name="growing-config"]');
    return parseQuizCheckMs(JSON.parse(m?.getAttribute('content') ?? '{}'));
  } catch {
    return QUIZ_CHECK_MS;
  }
}

export function readTiming(): SubmitTiming {
  try {
    const m = document.querySelector('meta[name="growing-config"]');
    return parseTiming(JSON.parse(m?.getAttribute('content') ?? '{}'));
  } catch {
    return DEFAULT_TIMING;
  }
}
